import { ViewportScroller } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { CrudService } from 'src/app/service/crud.service';
import { SharedService } from 'src/app/service/shared.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-driver-claim-approval',
  templateUrl: './driver-claim-approval.component.html',
  styleUrls: ['./driver-claim-approval.component.css']
})
export class DriverClaimApprovalComponent implements OnInit {
  reimbursementHeader: any = {};
  driverDetails: any = {};
  driverDocuments: any[] = [];
  driverHistory: any[] = [];

  tmc: any = '';
  multipleRows: any[] = [];
  Remarks: any = '';
  claimId: any = '';
  Status: any = '';
  constructor(private _crudService: CrudService, private _sharedService: SharedService, private viewportScroller: ViewportScroller, private route: ActivatedRoute, private _router: Router) {
    this.route.queryParams.subscribe(params => {
      if (params['Id'] && params['ClaimId']) {
        setTimeout(() => {
          this.claimId = params['ClaimId'];
          this.getDriverDetails(params['ClaimId']);
        }, 0);
      }
    });
  }

  ngOnInit() {
    this.viewportScroller.scrollToPosition([0, 0]);
  }

  getDriverDetails(claimId: any) {
    this._crudService.get('/Reimbursement/GetDetailsByClaimId?claimId=' + claimId)
      .subscribe((res: any) => {
        const data = res.Data;
        this.reimbursementHeader = {
          MEMBER_TMC: data.MEMBER_TMC,
          MEMBER_NAME: data.MEMBER_NAME,
          MEMBER_EMAIL: data.MEMBER_EMAIL,
          MEMBER_DESIGNATION: data.MEMBER_DESIGNATION,
          MEMBER_SBU: data.MEMBER_SBU,
          MEMBER_BAND: data.MEMBER_BAND,
          STATUS: data.STATUS,
          YearMonth: data.YearMonth
        };
        let driverData = data._dRIVER_DETAILS[0];
        this.driverDetails = {
          DRIVER_NAME: driverData.DRIVER_NAME,
          DRIVER_CONTACT_NO: driverData.DRIVER_CONTACT_NO,
          DRIVER_PHONE_NO: driverData.DRIVER_PHONE_NO,
          DRIVER_ADDRESS: driverData.DRIVER_ADDRESS
        }
        this.driverDocuments = data._dRIVER_DOCUMENTS || [];
      })
  }



  Update(status: any) {
    if (status == 'Approve') {
      this.Status = this._sharedService.ApprovedbyManager
    } else if (status == 'Reject') {
      this.Status = this._sharedService.RejectedByManager
    }
    if (!this.Remarks || this.Remarks.trim() === '') {
      Swal.fire({
        title: 'Remarks Required',
        text: 'Remarks is mandatory.',
        confirmButtonText: 'OK'
      });
      return;
    }
    Swal.fire({
      title: 'Are you sure?',
      html: `You are about to approve reimbursement request(s).<br/><br/>Do you want to continue?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, Approve',
      cancelButtonText: 'No, Cancel',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33'
    }).then((result) => {
      if (result.isConfirmed) {
        const payload = {
          CLAIM_ID: this.claimId,
          STATUS: this.Status,
          REMARKS: this.Remarks,
          MODIFIED_BY: sessionStorage.getItem('userId')
        }
        this._crudService.post('/Reimbursement/UpdateStatus', payload)
          .subscribe(
            res => {
              if (res.Status) {
                Swal.fire({
                  icon: 'success',
                  title: 'Approved!',
                  text: 'Selected rows processed successfully.',
                  confirmButtonText: 'OK'
                });
              }
            },
            err => {
              console.error(err);
              Swal.fire({
                icon: 'error',
                title: 'Error!',
                text: 'Something went wrong while processing.',
                confirmButtonText: 'OK'
              });
            }
          );
      }
    });
  }




}